import React, { PureComponent } from 'react'
import ExpandableList from '~/components/ExpandableList'
import uuidv4 from 'uuid/v4'
import liveIcon from '~/assets/icon-live.svg'
import Item from './item'

export default class LiveList extends PureComponent {
  renderItem = (itemData, handleClick) => {
    return (
      <Item
        key={`item-${uuidv4()}`}
        itemData={itemData}
        handleClick={handleClick}
      />
    )
  }

  render() {
    const moduleListConfig = {
      icon: liveIcon,
      headerText: 'Live',
      renderItem: this.renderItem,
      listData: this.props.liveData,
    }
    return <ExpandableList {...moduleListConfig} />
  }
}



// WEBPACK FOOTER //
// ./src/modules/Live/index.js